enum RequestPurchasesPremission {
  Prem_Request_Purchase_New_Request = 'Prem_Request_Purchase_New_Request',
  Prem_Request_Purchase_Main = 'Prem_Request_Purchase_Main',
  Prem_Request_Purchase_Open_Request = 'Prem_Request_Purchase_Open_Request',
  Prem_Request_Purchase_Edit_Status = 'Prem_Request_Purchase_Edit_Status',
  Prem_Request_Purchase_Add_Item = 'Prem_Request_Purchase_Add_Item',
  Prem_Request_Purchase_Edit_Item = 'Prem_Request_Purchase_Edit_Item',
  Prem_Request_Purchase_Delete_Item = 'Prem_Request_Purchase_Delete_Item',
  Prem_Request_Purchase_Suppliar_Requests = 'Prem_Request_Purchase_Suppliar_Requests',
  Prem_Request_Purchase_Convert_Sale = 'Prem_Request_Purchase_Convert_Sale',
  Prem_Request_Purchase_Admin = 'Prem_Request_Purchase_Admin',
  Prem_Request_Purchase_Approve = 'Prem_Request_Purchase_Approve',
  Prem_Request_Add_Pdf_To_Request = 'Prem_Request_Add_Pdf_To_Request',
  Prem_Request_Remove_Pdf_From_Request = 'Prem_Request_Remove_Pdf_From_Request',
  Prem_Request_Purchase_View_Pdf = 'Prem_Request_Purchase_View_Pdf',
  Prem_Request_Purchase_Offers = 'Prem_Request_Purchase_Offers',
  Prem_Request_Purchase_Offers_Delete = 'Prem_Request_Purchase_Offers_Delete',
}

export default RequestPurchasesPremission;
